'use client';

import { forwardRef, InputHTMLAttributes, useRef } from 'react';
import CheckedBox from '@fluentui/svg-icons/icons/checkbox_checked_20_filled.svg';
import UncheckedBox from '@fluentui/svg-icons/icons/checkbox_unchecked_20_filled.svg';

type Props = InputHTMLAttributes<HTMLInputElement>;

const Checkbox = forwardRef<HTMLInputElement, Props>((props, _externalRef) => {
  const internalRef = useRef<HTMLInputElement>(null);
  const { checked, name, disabled, ...otherProps } = props;

  return (
    <div
      className={`relative flex h-5 w-5 items-center justify-center ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <input
        ref={(el) => {
          internalRef.current = el;
          if (typeof _externalRef === 'function') _externalRef(el);
          else if (_externalRef) _externalRef.current = el;
        }}
        id={name}
        name={name}
        type="checkbox"
        className={`absolute inset-0 size-full opacity-0 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        {...otherProps}
        checked={checked}
        disabled={disabled}
        readOnly={!disabled} // avoid uncontrolled warning when using manual toggle
      />
      <span
        onClick={() => {
          if (!disabled) internalRef.current?.click();
        }}
      >
        {checked ? (
          <CheckedBox
            className={disabled ? 'fill-gray-300' : 'fill-blue-600'}
          />
        ) : (
          <UncheckedBox
            className={disabled ? 'fill-gray-300' : 'fill-gray-400'}
          />
        )}
      </span>
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
